import { render, staticRenderFns } from "./ecSettingsManage.vue?vue&type=template&id=283381cb&scoped=true&"
import script from "./ecSettingsManage.vue?vue&type=script&lang=js&"
export * from "./ecSettingsManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283381cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('283381cb')) {
      api.createRecord('283381cb', component.options)
    } else {
      api.reload('283381cb', component.options)
    }
    module.hot.accept("./ecSettingsManage.vue?vue&type=template&id=283381cb&scoped=true&", function () {
      api.rerender('283381cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/comm/ecSettingsManage/ecSettingsManage.vue"
export default component.exports